import React, { useEffect } from 'react'
import About from '../components/About'
import ComingSoon from '../components/ComingSoon'
import Contact from '../components/Contact'

function Home() {
  useEffect(()=> window.scrollTo(0,0), [])
  return (
    <div>
        <div>
          <section
            id="hero-DAlsTw"
            className="text-orange-100 font-energetic"
            style={{
              backgroundImage:
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://images.pexels.com/photos/270288/pexels-photo-270288.jpeg")',
              backgroundSize: "cover",
              backgroundPosition: "center center",
              height: "150%",
            }}
          >
            <div
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="50"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-center"
              className="container max-w-screen-2xl mx-auto flex px-5 py-24 pt-64 md:flex-row flex-col items-center"
            >
              <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center ">
                <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-orange-100">
                  Welcome to Radio O
                </h1>
                <p className="mb-8 leading-relaxed text-orange-100">
                  Connecting Manchester through sound. Tune in 24/7
                  <br />
                  with the audio player below
                </p>
                <audio controls autoPlay>
                  <source
                    src="https://stream-170.zeno.fm/htrnfxelk4otv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJodHJuZnhlbGs0b3R2IiwiaG9zdCI6InN0cmVhbS0xNzAuemVuby5mbSIsInJ0dGwiOjUsImp0aSI6IlplTW1tMzF1U3VhUjNQODRuRW5ESEEiLCJpYXQiOjE3NDM5NDUyMDIsImV4cCI6MTc0Mzk0NTI2Mn0.U836KrwBBbn_FeSXoslLqaZ6dwuWzSkULX3AOKL4Dwk"
                    type="audio/mpeg"
                  />
                  Your browser does not support the audio element.
                </audio>
              </div>
            </div>
          </section>
        </div>
        <About />
        <ComingSoon />
        <Contact />
      </div>
  )
}

export default Home